import { render } from "./Depth.vue?vue&type=template&id=606eb9c5"
import script from "./Depth.vue?vue&type=script&lang=js"
export * from "./Depth.vue?vue&type=script&lang=js"

import "./Depth.vue?vue&type=style&index=0&id=606eb9c5&lang=css"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__